export default __webpack_public_path__ + "static/media/editPen.3f072c19.webp";